import { useTranslation } from 'react-i18next';

import { CheckItem } from 'Src/feature/check/models';

/**
 * Build common display copy for a check item name
 */
const useCheckItemName = () => {
  const { t } = useTranslation();
  const getCheckItemName = (options: { checkItem: Pick<CheckItem, 'splitBy'> | undefined, menuItemName: string | undefined }) => {


    // let name = checkItem.menuItem.combinedName;
    let name = options.menuItemName || '';
    // append a split fraction to name if split has happened on item
    if (options.checkItem?.splitBy) {
      // quantity = checkItem.reportQuantity ?? parseFloat((quantity / checkItem.splitBy).toFixed(2));
      name = t('checkItem.nameSplitBy', {
        numerator: 1,
        denominator: options.checkItem.splitBy,
        name,
      });
    }
    return name;
  };
  return { getCheckItemName };
};

export { useCheckItemName };
